// components/ui/SuccessModal.jsx
import React from 'react';
import { CheckCircle, X, Mail } from 'lucide-react';

export default function SuccessModal({ isOpen, onClose, title, message, emailSent }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden">
        {/* En-tête avec cercle de succès */}
        <div className="relative pt-6 pb-4 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <h3 className="text-xl font-semibold text-gray-800">{title || 'Succès !'}</h3>
        </div>

        {/* Message */}
        <div className="px-6 pb-4 text-center">
          <p className="text-gray-600">{message}</p>
          
          {emailSent !== undefined && (
            <div className="mt-4 p-3 bg-blue-50 rounded-lg flex items-center gap-3 text-left">
              <Mail className="w-5 h-5 text-blue-500 flex-shrink-0" />
              <div className="text-sm text-blue-700">
                {emailSent ? (
                  <>Un email a été envoyé à l'utilisateur avec ses identifiants.</>
                ) : (
                  <>L'email n'a pas pu être envoyé. Vérifiez la configuration SMTP.</>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Bouton */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full bg-primary-500 hover:bg-primary-600 text-white font-medium py-2 px-4 rounded-lg transition"
          >
            Continuer
          </button>
        </div>
      </div>
    </div>
  );
}